import React, { useEffect, useState, useContext } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { adminDashboard } from '../Network/Administration'
import { LanguageContext } from '../Language/LanguageContext'
import { Loading } from '../Library'
import { Line, Doughnut } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAsterisk, faPaperclip, faUser, faUserSlash } from '@fortawesome/free-solid-svg-icons'
import "./AdminDashboard.css"
import dayjs from 'dayjs';

function AdminDashboard() {
    const [isLoading, setLoading] = useState(false)
    const [countUserByMonth, setCountUserByMonth] = useState([])
    const [listRankByBuilding, setRankByBuilding] = useState([])
    const [latestFeedback, setLatestFeedback] = useState([])
    const [userActivity, setUserActivity] = useState({ active: 0, inActive: 0 })

    const fetchDashboard = () =>{
        setLoading(true)
        adminDashboard(
            (data)=>{
                setCountUserByMonth(data.create_user_by_month)
                setRankByBuilding(data.rank_user_building)
                setLatestFeedback(data.latest_feedback)
                setUserActivity({
                    active: data.user_activity.active_user,
                    inActive: data.user_activity.inactive_user
                })
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            }
        )
    }

    useEffect(()=>{
        fetchDashboard()
    },[])

    return (
        <div id="admin-dashboard">
            { isLoading ? <Loading/>: null }
            <Row>
                <Col xs={12}>
                    <CountByMonth data={countUserByMonth}/>
                </Col>
                <Col sm={6}>
                    <RankingBuilding data={listRankByBuilding}/>
                </Col>
                <Col sm={6}>
                    <UserActivity
                    active={userActivity.active}
                    inactive={userActivity.inActive}
                    />
                    <LatestFeedback data={latestFeedback}/>
                </Col>
            </Row>
        </div>
    )
}

function CountByMonth({ data }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    var labels = []
    var countData = []

    data.forEach((item)=>{
        let formattedMonth = dayjs(item.createMonth).format("MMMM")
        labels.push(formattedMonth)
        countData.push(item.countUser)
    })

    return(
        <div className="dashboard-item">
            <div className="title">{lang.count_user_by_month}</div>
            <div style={{ marginTop: 10, height: 300 }}>
                <Line
                legend={{ display: false }}
                data={{
                    labels: labels,
                    datasets: [
                        {
                            data: countData,
                            borderColor: '#00275e',
                            lineTension: 0.1,
                            pointBackgroundColor: '#00275e',
                            pointRadius: 6,
                            pointHoverRadius: 5,
                            pointHitRadius: 5,
                            fill: false
                        }
                    ]
                }}
                options={{
                    maintainAspectRatio: false,
                    scales:{
                        yAxes: [
                            {
                                ticks:{
                                    beginAtZero: true,
                                    step: 2
                                }
                            }
                        ]
                    }
                }}
                
                />
            </div>
        </div>
    )
}

function RankingBuilding({ data }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    var labelsBuilding = []
    var dataBuilding = []

    data.forEach((item)=>{
        labelsBuilding.push(item.buildingName)
        dataBuilding.push(item.countUser)
    })

    const DataItem = ({ buildingName, count, rank }) =>{
        return(
            <div className="rank-item">
                <div className="rank-title">{rank}.&nbsp;{buildingName}</div>
                <div className="rank-desc">{count.toLocaleString() || 0} {lang.people}</div>
            </div>
        )
    }

    return(
        <div className="dashboard-item">
            <div className="title">{lang.ranking_building}</div>
            <div style={{ marginTop: 10, height: 300 }}>
                <Doughnut
                data={{
                    labels: labelsBuilding,
                    datasets:[
                        {
                            data: dataBuilding,
                            backgroundColor:[
                                'rgba(255, 99, 132, 0.5)',
                                'rgba(255, 159, 64, 0.5)',
                                'rgba(255, 205, 86, 0.5)',
                                'rgba(75, 192, 192, 0.5)',
                                'rgba(54, 162, 235, 0.5)',
                                'rgba(230, 230, 230, 0.5)'
                            ]
                        }
                    ]
                }}
                options={{
                    maintainAspectRatio: false
                }}
                />
            </div>
            <div style={{ marginTop: 20 }}> 
            { data?.map((item, key) =>
                <DataItem
                key={key}
                rank={key + 1}
                buildingName={item.buildingName}
                count={item.countUser}
                />
            )}
            </div>
        </div>
    )
}

function LatestFeedback({ data }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    const DataItem = ({ title, date, isAttach, id }) =>{
        return(
            <Link className="feedback-item" to={`/feedback/${id}`}>
                <div className="feedback-icon">
                    <FontAwesomeIcon icon={faAsterisk} color={"orange"}/>
                    { isAttach ?
                    <FontAwesomeIcon icon={faPaperclip} color="gray" style={{ marginLeft: 5 }}/> : null
                    }
                </div>
                <div>
                    <div className="feedback-title">{title}</div>
                    <div className="feedback-desc">{dayjs(date).format("D MMM YYYY H:mm")}</div>
                </div>
            </Link>
        )
    }

    return(
        <div className="dashboard-item">
            <div className="title">{lang.latest_feedback}</div>
            <div style={{ marginTop: 10 }}>
                { data.map((item, key) =>
                <DataItem
                key={key}
                id={item.id}
                title={item.title}
                date={item.createdDate}
                isAttach={item.attachImagePath !== null ? true:false}
                />
                )}
            </div>
            { data.length === 0 ?
            <div style={{ textAlign: 'center' }}>
                {lang.no_feedback}
            </div>
            : null
            }
            <div className="see-more-feedback"> 
                <Link to="/feedback">
                    {lang.see_more}
                </Link>
            </div>
        </div>
    )
}

function UserActivity(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    const activeUser = props.active
    const inActiveuser = props.inactive

    const data = {
        labels: [lang.active, lang.in_active],
        datasets: [
          {
            label: 'User activity',
            backgroundColor: ["#00275e", "lightgray"],
            data: [activeUser, inActiveuser]
          }
        ]
      };

    return(
        <div className="user-activity-section dashboard-item">
            <div className="section-title">{lang.user_activity}</div>
            <div className="chart-container">
                <Doughnut 
                data={data}
                options={{ maintainAspectRatio: false }}
                />
            </div>
            <div className="chart-detail">
                <div className="item">
                    <div className="number">{activeUser}</div>
                    <div className="chart-title">
                        <FontAwesomeIcon icon={faUser} style={{marginRight: 5}}/>
                        {lang.active}
                    </div>
                </div>
                <div className="item">
                    <div className="number">{inActiveuser}</div>
                    <div className="chart-title">
                        <FontAwesomeIcon icon={faUserSlash} style={{marginRight: 5}}/>
                        {lang.in_active}
                    </div>
                </div>
            </div>
        </div>
    )
}


export default AdminDashboard
